export default __webpack_public_path__ + "static/media/second_engagement_card.6c4f617a.svg";